/**
 * Mengubah body JSON Laravel/Axios jadi array (endpoint list yang mengembalikan [] atau {}).
 */
export function asApiArray(payload) {
  if (payload == null) return []
  if (Array.isArray(payload)) return payload
  return Object.values(payload)
}
